import { defineComponent, createBlock, openBlock } from 'vue';
import _sfc_main$1 from './basler-components.es99.js';
/* empty css                        */

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "SpacerBlock",
  props: {
    spacingGrid: {},
    width: {}
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return openBlock(), createBlock(_sfc_main$1, {
        "spacing-grid": props.spacingGrid,
        width: props.width
      }, null, 8, ["spacing-grid", "width"]);
    };
  }
});

export { _sfc_main as default };
